module.exports = __webpack_public_path__ + "img/realmofkings.6eb7a6b6.svg";